module.exports = __webpack_public_path__ + "img/ring_r_e_0_1.07b6617e.png";